<div class="palette">
  <div class="search-row">
    <mat-icon>search</mat-icon>
    <input
      class="query-input"
      placeholder="Search pages, accounts, users, pairs, assets, liquidity providers…"
      [value]="query()"
      (input)="onQueryChange($any($event.target).value)"
      (keydown)="onKeydown($event)"
    />
  </div>

  <div class="results">
    @if (query().trim() && !flatResults().length) {
      <div class="empty-state">No results for "{{ query() }}"</div>
    }

    @for (group of resultGroups(); track group.label) {
      <div class="result-group">
        <div class="group-label">{{ group.label }}</div>
        @for (result of group.results; track (result.groupPrefix || "") + result.label + (result.sublabel || "")) {
          <button
            type="button"
            class="result-row"
            [class.selected]="isSelected(result)"
            (click)="select(result)"
            (mouseenter)="hover(result)"
          >
            <span class="result-icon">
              @if (result.icon) {
                @switch (result.icon.kind) {
                  @case ("material") {
                    <mat-icon>{{ result.icon.ligature }}</mat-icon>
                  }
                  @case ("asset") {
                    <lib-asset-icon [code]="result.icon.code" />
                  }
                  @case ("pair") {
                    <span class="result-icon-pair">
                      <lib-asset-icon class="result-icon-pair__base" [code]="result.icon.baseCode" />
                      <lib-asset-icon class="result-icon-pair__quote" [code]="result.icon.quoteCode" />
                    </span>
                  }
                }
              }
            </span>
            <span class="result-text">
              <span class="result-label">
                @if (result.groupPrefix) {
                  <span class="result-group-prefix">{{ result.groupPrefix }} › </span>
                }
                {{ result.label }}
              </span>
              @if (result.sublabel) {
                <span class="result-sublabel">{{ result.sublabel }}</span>
              }
            </span>
          </button>
        }
      </div>
    }
  </div>
</div>
